import React, { Component } from "react";
import Avatar from "../../avatar";
import TextToMask from "../../text-to-mask";

import "./company.css";

class Company extends Component {
  render() {
    return (
      <div style={{ padding: 0, margin: 0 }}>
        {!!this.props.info.slug && !!this.props.info.fiscal_informations && (
          <div
            className="companies__company"
            onTouchTap={() => this.props.onClick(this.props.info)}
          >
            <Avatar name={this.props.info.slug} />
            <div className="company__info">
              <p className="company__name">{this.props.info.slug}</p>
              <TextToMask
                className="company__cnpj"
                value={this.props.info.fiscal_informations.cnpj}
                mask="cnpj"
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Company;



// WEBPACK FOOTER //
// ./src/components/support/companies/company/index.js